<template>
    <body class="print">
        <main class="print-report csat">
            <div class="print__inner">
                <section class="print__section">
                    <div class="print__header">
                        <h2 class="print__title">{{ props.level }}</h2>
                        <div class="print__info">
                            <div class="date"><q-icon name="calendar_today" /> {{ summaryData?.issueDate }}</div>
                        </div>
                    </div>
                    <div class="print__body">
                        <div class="print--top">
                            <p class="txt">{{ comSchoolAndGrade }}</p>
                            <h3 class="title">
                                {{ globalStore.userInfo.studentName }}님의 예측 등급은 <span class="level">{{ summaryData?.grade }}등급 입니다!</span>
                            </h3>
                        </div>
                        <div class="print__content">
                            <h4 class="content__title">수능모의평가 결과</h4>
                            <div class="content__body">
                                <ul class="result__list">
                                    <li class="result__item reading">
                                        <span class="result__title">점수</span>
                                        <span class="result__txt">
                                            <span class="score">{{ summaryData?.point }}</span
                                            ><span class="standard">100</span>점
                                        </span>
                                    </li>
                                    <li class="result__item solve">
                                        <span class="result__title">맞힌 문항수</span>
                                        <span class="result__txt">
                                            <span class="score">{{ summaryData?.correctCount }}</span
                                            ><span class="standard">34</span>문항
                                        </span>
                                    </li>
                                    <li class="result__item time">
                                        <span class="result__title">소요 시간</span>
                                        <span class="result__txt">
                                            <!-- <span class="score">{{ summaryData?.elapsedMinute }}</span>분 -->
                                            <!-- <span class="score">
                        {{ summaryData?.elapsedMinute }}
                      </span> -->
                                            <template v-if="summaryData?.elapsedHour !== 0">
                                                <span class="score"> {{ summaryData?.elapsedHour }} </span>시간
                                            </template>
                                            <template v-if="summaryData?.elapsedMinute !== 0">
                                                <span class="score"> {{ summaryData?.elapsedMinute }} </span>분
                                            </template>
                                            <template v-if="summaryData?.elapsedSecond !== 0">
                                                <span class="score"> {{ summaryData?.elapsedSecond }} </span>초
                                            </template>
                                            <span class="standard">60</span>분
                                        </span>
                                    </li>
                                </ul>
                                <p class="detail__txt bold" v-html="summaryData?.satComment"></p>
                            </div>
                        </div>
                        <div class="print__content">
                            <div class="content__header">
                                <h4 class="content__title">지문 분석</h4>
                            </div>
                            <div class="content__body">
                                <table class="detail__table analysis__table">
                                    <thead>
                                        <tr>
                                            <th>영역</th>
                                            <th>번호</th>
                                            <th>갈래/주제</th>
                                            <th>지문</th>
                                            <th>KReaD</th>
                                            <th>글자수</th>
                                            <th>정답률</th>
                                            <th>목표 시간</th>
                                            <th>풀이 시간</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="passageList">
                                        <tr v-for="(vData, index) in Object.values(passageList?.passageResultListN)">
                                            <td v-if="index === 0" :rowspan="passageList?.passageResultListN.length">비문학</td>
                                            <td style="font-size: 1.2vw; white-space: nowrap">{{ vData?.firstNo }} ~ {{ vData?.lastNo }}</td>
                                            <td>
                                                {{ vData?.topic }}
                                            </td>
                                            <td class="content">
                                                {{ vData?.passageName }}
                                            </td>
                                            <td>
                                                {{ vData?.kreadScore }}
                                            </td>
                                            <td>
                                                {{ vData?.bookDesc }}
                                            </td>
                                            <td :class="vData?.correctRate < 50 ? 'over-time' : ''">{{ vData?.correctRate }}%</td>
                                            <td>
                                                {{ vData?.solveTime && getTimeStringSecondsKor(vData?.solveTime) }}
                                            </td>
                                            <td :class="vData?.solveTime < vData?.elapsedTime ? 'over-time' : ''">
                                                {{ vData?.elapsedTime && getTimeStringSecondsKor(vData?.elapsedTime) }}
                                            </td>
                                        </tr>
                                        <tr v-for="(vData, index) in Object.values(passageList?.passageResultListL)">
                                            <td v-if="index === 0" :rowspan="passageList?.passageResultListL.length">문학</td>
                                            <td style="font-size: 1.2vw; white-space: nowrap">{{ vData?.firstNo }} ~ {{ vData?.lastNo }}</td>
                                            <td>
                                                {{ vData?.topic }}
                                            </td>
                                            <td class="content">
                                                {{ vData?.passageName }}
                                            </td>
                                            <td>
                                                {{ vData?.kreadScore }}
                                            </td>
                                            <td>
                                                {{ vData?.bookDesc }}
                                            </td>
                                            <td :class="vData?.correctRate < 50 ? 'over-time' : ''">{{ vData?.correctRate }}%</td>
                                            <td>
                                                {{ vData?.solveTime && getTimeStringSecondsKor(vData?.solveTime) }}
                                            </td>
                                            <td :class="vData?.solveTime < vData?.elapsedTime ? 'over-time' : ''">
                                                {{ vData?.elapsedTime && getTimeStringSecondsKor(vData?.elapsedTime) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="print__section">
                    <div class="print__content">
                        <div class="content__header">
                            <h4 class="content__title">문항 분석</h4>
                        </div>
                        <div class="content__body">
                            <div class="content__section">
                                <h5 class="detail__title">사고 유형별 강약점</h5>
                                <div class="detail__graph columnchart">
                                    <!-- 그래프 넣어주세요. -->
                                    <div style="height: 600px; width: 100%; padding: 20px; background-color: #fafafa">
                                        <!-- <div style="width: 100%;display: grid;justify-items: end;">
                      <div style="display: inline-flex; align-items: center;font-size: 0.8vw;">
                        <div
                          style="width:2vw;height: 0.75vw; background-color: #8E43F0; margin-right: 10px;border-bottom-right-radius: 50px;border-top-right-radius: 50px; ">
                        </div>
                        <div style="font-weight: 500;">내 정답률</div>
                      </div>
                    </div> -->
                                        <columChart v-if="analysisChartData.length > 0" :chartData="analysisChartData" :chartFontSizeData="commonPrintColumnChartFontData" width="1550px" height="95%" />
                                    </div>
                                </div>
                                <div class="reference">
                                    <p class="reference__title"><span class="required">*</span>사고 유형</p>
                                    <p class="reference__txt">
                                        사실적독해 : 글에 표면적으로 드러난 정보를 파악하여 글의 내용을 체계적으로 이해하는 능력​<br />
                                        추론적독해 : 생략된 정보를 추론하고, 글에 드러난 단서를 근거로 글쓴이의 의도나 목적을 추측하는 능력​​<br />
                                        비판적독해 : 글에 사용된 자료가 정확한지, 글쓴이의 주장이나 의견이 타당한지 점검하며 글을 읽는 능력​​<br />
                                        감상적독해 : 글에서 공감하거나 감동적인 부분을 읽고 글에 담긴 가치를 종합적으로 이해하는 능력​​<br />
                                        개념 : 개념을 적용하여 글을 이해하고 판단하는 능력​​<br />
                                        어휘 : 글에 나온 어휘의 의미를 알고 문맥에 맞게 사용하며 적용할 수 있는 능력
                                    </p>
                                </div>
                            </div>
                            <div class="content__section">
                                <h5 class="detail__title">질문 유형별 강약점</h5>
                                <div class="detail__graph columnchart">
                                    <!-- 그래프 넣어주세요. -->
                                    <div style="height: 600px; width: 100%; padding: 20px; background-color: #fafafa">
                                        <!-- <div style="width: 100%;display: grid;justify-items: end;">
                      <div style="display: inline-flex; align-items: center;font-size: 0.8vw;">
                        <div
                          style="width: 2vw; height: 0.75vw; background-color: rgb(142, 67, 240); margin-right: 10px; border-bottom-right-radius: 50px; border-top-right-radius: 50px;">
                        </div>
                        <div style="font-weight: 500;">내 정답률</div>
                      </div>
                    </div> -->
                                        <columChart v-if="problemTypeChartData.length > 0" :chartData="problemTypeChartData" :chartFontSizeData="commonPrintColumnChartFontData" width="1550px" height="95%" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="print__section">
                    <div class="print__content">
                        <h4 class="content__title">문항별 풀이 결과</h4>
                        <div class="content__body">
                            <table class="detail__table item-analysis__table">
                                <thead>
                                    <tr>
                                        <th>영역</th>
                                        <th>번호</th>
                                        <th>사고 유형</th>
                                        <th>학습 개념 상세</th>
                                        <th>정답</th>
                                        <th>내답안</th>
                                        <th>정답여부</th>
                                    </tr>
                                </thead>
                                <tbody v-if="problemList">
                                    <tr v-for="(vData, index) in Object.values(problemList?.problemResultListN)">
                                        <td v-if="index === 0" :rowspan="problemList?.problemResultListN.length">비문학</td>
                                        <td>{{ vData?.problemOrd }}</td>
                                        <td>{{ vData?.analysisName }}</td>
                                        <td class="content">{{ vData?.learningConceptName }}</td>
                                        <td>{{ vData?.correct }}</td>
                                        <td>{{ vData?.answer }}</td>
                                        <td>
                                            <span :class="'correct' + (vData.correctYn ? '1' : '3')">정답 </span>
                                        </td>
                                    </tr>
                                    <tr v-for="(vData, index) in Object.values(problemList?.problemResultListL)">
                                        <td v-if="index === 0" :rowspan="problemList?.problemResultListL.length">문학</td>
                                        <td>{{ vData?.problemOrd }}</td>
                                        <td>{{ vData?.analysisName }}</td>
                                        <td class="content">{{ vData?.learningConceptName }}</td>
                                        <td>{{ vData?.correct }}</td>
                                        <td>{{ vData?.answer }}</td>
                                        <td>
                                            <span :class="'correct' + (vData.correctYn ? '1' : '3')">정답 </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    </body>
</template>

<script setup>
import { computed, onMounted, ref, watch, defineProps, reactive } from 'vue';
import { GlobalStore } from '@/store';
import _ from 'lodash';
import { StudyStore } from '@/store/modules/study';
import { getTimeStringSecondsKor, timeStringSecondsKorToSec } from '@/helpers/utils';
import { analysis, difficult, problemType } from '@/helpers/qbankParser/qbankMeta';
import { useQuasar } from 'quasar';
import columChart from '@/components/chart/columChart.vue';
import { commonPrintColumnChartFontData } from '@/config/styleConfig';
import Comm from '@/components/common.js';

const $q = useQuasar();
const user = ref(null);
const globalStore = GlobalStore();
const summaryData = ref(null);
const passageList = ref(null);
const problemList = ref(null);
const analysisChartData = ref([]);
const problemTypeChartData = ref([]);
const comSchoolAndGrade = computed(() => Comm.getStrSchoolAndGrade());
const props = defineProps({
    reportData: {
        default: null,
        // default: {
        //   areaCode: "02",
        //   learningHistorySeq: 2338,
        //   learningTypeCode: 1,
        //   lesson: 1,
        // }
    },
    level: {
        default: '수능모의평가 분석리포트',
    },
});
onMounted(() => {
    // summaryData.value = {
    //   totalAccuracyRate: testData.totalAccuracyRate,
    //   coreResult: testData.totalLearningResult.coreResult,
    //   earnestResult: testData.totalLearningResult.earnestResult,
    //   vocabularyResult: testData.totalLearningResult.vocabularyResult,
    // }
    // passageList.value = testData.passageList
    // getReportSat({ learningHistorySeq: 760 }, (rs) => {
    if (props?.reportData) {
        const rs = props?.reportData;
        // console.log('수능 데이터:', rs, props.level)
        // const rs = testData;
        summaryData.value = {
            correctCount: rs.correctCount,
            point: rs.point,
            grade: rs.grade,
            point: rs.point,
            elapsedHour: rs.elapsedHour,
            elapsedMinute: rs.elapsedMinute,
            elapsedSecond: rs.elapsedSecond,
            satComment: rs.satComment,
            issueDate: rs.issueDate,
            schoolGrade: rs.schoolGrade,
        };
        passageList.value = { passageResultListL: rs.passageResultListL, passageResultListN: rs.passageResultListN };
        problemList.value = { problemResultListL: rs.problemResultListL, problemResultListN: rs.problemResultListN };
        // console.log(passageList);
        // console.log(problemList);
        let tmpChartData = [];

        Object.entries(analysis).forEach(([k, v]) => {
            if (rs.analysisResult['analysis' + k] > -1) {
                if (v.ord < 4) {
                    tmpChartData.push({
                        category: v.label + ' 독해',
                        value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                        ord: v.ord,
                    });
                } else {
                    tmpChartData.push({
                        category: v.label,
                        value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                        ord: v.ord,
                    });
                }
            }
        });
        // Object.entries(testData.analysisResult).forEach(([k, v]) => {

        //   const tmpKey = k.replace('analysis', '');
        //   if (analysis[tmpKey].ord < 4) {
        //     tmpChartData.push({
        //       category: analysis[tmpKey].label + " 독해",
        //       value1: v,
        //     })
        //   } else {
        //     tmpChartData.push({
        //       category: analysis[tmpKey].label,
        //       value1: v,
        //     })
        //   }
        // });
        // analysisChartData.value = tmpChartData;
        analysisChartData.value = _.sortBy(tmpChartData, 'ord');
        let tmpProblemTypeChartData = [];
        Object.entries(problemType).forEach(([k, v]) => {
            tmpProblemTypeChartData.push({
                category: v,
                value1: rs.problemTypeResult[k] < 0 ? 0 : rs.problemTypeResult[k],
            });
        });
        problemTypeChartData.value = tmpProblemTypeChartData;
        // console.log(_.isEmpty(globalStore.userInfo));
        if (_.isEmpty(globalStore.userInfo)) {
            globalStore.getUserInfo();
            // console.log(globalStore.getUserInfo());
        }
        user.value = globalStore.userInfo;
    }
});
</script>

<style scoped lang="scss">
@import '../print.scss';
</style>
